import Hero from "@/components/home/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/home/Problem";
import Intro from "@/components/home/Intro";
import Process from "@/components/home/Process";
import CountdownSection from "@/components/home/CountdownSection";
import Benefits from "@/components/home/Benefits";
import WhoFor from "@/components/home/WhoFor";
import WhatIf from "@/components/home/WhatIf";
import FinalCTA from "@/components/home/FinalCTA";

export default function Home() {
  return (
    <main data-testid="page-home">
      <Hero />
      <Marquee />
      <Problem />
      <Intro />
      <Process />
      <CountdownSection />
      <Benefits />
      <WhoFor />
      <WhatIf />
      <FinalCTA />
    </main>
  );
}
